import { fetchAdminBillingAccountRelations } from 'app/queries/billing/fetchAdminBillingAccountRelations';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { BillingAccountService, type GetBillingAccountResponseDto } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { billingKeys } from 'app/queries/billing/billingKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.account>>;

export const createFetchBillingAccountQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ baId }], signal }: TParams): Promise<GetBillingAccountResponseDto> => {
    const [account, relations] = await Promise.all([
      call(() => cancelOnSignal(BillingAccountService.adminFindOne({ baId }), signal)),
      fetchAdminBillingAccountRelations(call, baId, signal),
    ]);
    return { ...account, ...relations };
  };
